/* eslint-disable react/jsx-handler-names */
import React, { useContext, useEffect, useState } from 'react';
import cn from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import isUndefined from 'lodash/isUndefined';
import { browserHistory } from 'react-router';

import Icon from '../../../Icon';
import InviteGuestPopup from '../InviteGuestPopup';
import { OTContext } from '../../../../redux/opentok/context';
import { useToggleFlag } from '../../../../hocs/useToogleFlag';
import { VIRTUAL_VISIT_INVITE_TYPE } from '../../../../constants';
import { LOGIN, VIRTUAL_ROOM } from '../../../../constants/routes';
import { trackUserAction } from '../../../../utils/sentry/sentryMethods';
import { ConnectionShape } from '../../../../redux/opentok/helpers/shapes';
import { currentLocationSelector } from '../../../../redux/common/selectors';
import { useVirtualVisit } from '../../../../redux/opentok/hooks/useVirtualVisit';
import { selectInvitationTypeFromConfig } from '../../../../redux/healthboard/selectors';
import styles from './styles.styl';

function PublisherBtns({ publisher, disabled }) {
  const { entity } = publisher;
  const { endVisit } = useContext(OTContext);
  const inviteType = useSelector(selectInvitationTypeFromConfig);
  const { viewOptions } = useVirtualVisit();
  const [opened, open, close] = useToggleFlag();
  const location = useSelector(currentLocationSelector);
  const [hasAudio, setHasAudio] = useState(true);
  const [hasVideo, setHasVideo] = useState(true);

  useEffect(() => {
    if (!isUndefined(get(entity, 'stream.hasAudio'))) {
      setHasAudio(get(entity, 'stream.hasAudio'));
    }
    if (!isUndefined(get(entity, 'stream.hasVideo'))) {
      setHasVideo(get(entity, 'stream.hasVideo'));
    }
  }, [publisher]);

  const audioIcon = hasAudio ? 'sound-on' : 'mute';
  const videoIcon = hasVideo ? 'video-on' : 'video-off';

  const handleAudioToggle = () => {
    const newValue = !hasAudio;
    trackUserAction(`[vv/publisher] audio button (${newValue ? 'ON' : 'OFF'})`);
    entity.publishAudio(newValue);
    setHasAudio(newValue);
  };
  const handleVideoToggle = () => {
    const newValue = !hasVideo;
    trackUserAction(`[vv/publisher] video button (${newValue ? 'ON' : 'OFF'})`);
    entity.publishVideo(newValue);
    setHasVideo(newValue);
  };

  const isVirtualRoom = location === VIRTUAL_ROOM;
  const hideCollapseBtn = [
    VIRTUAL_VISIT_INVITE_TYPE.IN_OFFICE,
    VIRTUAL_VISIT_INVITE_TYPE.GUEST,
    VIRTUAL_VISIT_INVITE_TYPE.PATIENT,
    VIRTUAL_VISIT_INVITE_TYPE.CONNECTION_ROOM,
  ].includes(inviteType);

  const hideInviteButton =
    [
      VIRTUAL_VISIT_INVITE_TYPE.CONNECTION_ROOM,
      VIRTUAL_VISIT_INVITE_TYPE.GUEST,
    ].includes(inviteType) || viewOptions.fullScreenView;

  const handleEndCall = () => {
    endVisit();
    if (isVirtualRoom) browserHistory.push(LOGIN);
  };

  return (
    <div className={cn(styles.root, { [styles.disabled]: disabled })}>
      <button onClick={handleAudioToggle} className={styles.btn} type="button">
        <Icon name={audioIcon} size={32} />
      </button>
      <button onClick={handleVideoToggle} className={styles.btn} type="button">
        <Icon name={videoIcon} size={32} />
      </button>
      <button
        type="button"
        className={cn(styles.btn, styles.hideOnMobView)}
        onClick={viewOptions.toggleFullScreenView}
      >
        <Icon
          size={32}
          name={viewOptions.fullScreenView ? 'exit-full-screen' : 'full-screen'}
        />
      </button>
      {!hideCollapseBtn && (
        <button
          onClick={viewOptions.collapseView}
          className={cn(styles.btn, styles.collapseBtn)}
          type="button"
        >
          <Icon name="detach" size={32} />
        </button>
      )}
      {!hideInviteButton && (
        <button onClick={open} className={styles.btn} type="button">
          <Icon name="invite-user" size={32} />
        </button>
      )}
      <If condition={opened}>
        <InviteGuestPopup opened={opened} onClose={close} />
      </If>
      <button
        className={cn(styles.btn, styles.endCall)}
        onClick={handleEndCall}
        type="button"
      >
        <Icon name="end-call" size={32} />
      </button>
    </div>
  );
}

PublisherBtns.propTypes = {
  disabled: PropTypes.bool,
  publisher: ConnectionShape,
};

export default PublisherBtns;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/PublisherBtns/index.jsx